import React, { useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { getHolidaySelectListAsync, checkedState, unCheckedState } from './holidaySelectSlice';
import { colors } from 'react-select/dist/declarations/src/theme';
import HolidayTypeDetail from '../holidayTypeDetail/HolidayTypeDetail';
import BillingType from '../billingType/BillingType';
import { Link } from 'react-router-dom';
import { KTIcon } from '../../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import CustomPagination from "../../../common/Pagination";
import { ShowToast } from '../../../common/Toastr';
import clsx from "clsx";
import { getValueFromResource } from '../../../common/timeLiveFunction';
const itemClass = 'ms-1 ms-lg-0';

const HolidaySelectItems = (props: any) => {
    const { holidaySelectList, t } = props;
    const dispatch = useAppDispatch();
    const { isLoading } = useAppSelector((state) => state.holidayType);


    const handleCheckboxChange = (e: any, IsSelected: any) => {
        if (e.target.checked) {
            dispatch(checkedState(IsSelected))
        } else {
            dispatch(unCheckedState(IsSelected))
        }
    };

    return (
        <>
       

                <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                    <thead>
                        <tr className="thHeading align-middle">
                            <th style={{ width: '95%' }}>
                                {/* {t('Holidays')} */}
                                {getValueFromResource('Holidays',dispatch, t)}

                                </th>
                            <th style={{ width: '5%' }}>
                                {/* {t('Selected')} */}
                            {getValueFromResource('Selected',dispatch, t)}

                                </th>
                        </tr>
                    </thead>
                    <tbody>
                        {holidaySelectList.length > 0 && holidaySelectList.map((holidaySelectListDetail: any, i: any) => (
                            <tr style={{ height: '35px' }} key={i}>
                                <td>
                                    {holidaySelectListDetail.HolidayType}
                                </td>
                                <td className='text-center'>
                                    <div className="form-check form-switch form-check-custom">
                                        <input
                                            type="checkbox"
                                            className="form-check-input custom-padding-right h-15px w-30px"
                                            id="IsSelected"
                                            checked={holidaySelectListDetail.IsSelected === true ? true : false}
                                            onChange={(e) => { handleCheckboxChange(e, holidaySelectListDetail.MasterHolidayTypeId) }}
                                        />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {holidaySelectList.length === 0 &&
                                    <div className=''>
                                        <p className='noDataFound'>
                                            {/* {t('No Record Found')} */}
                                            {getValueFromResource('No Record Found',dispatch, t)}

                                            </p>
                                    </div>
                                }

        </>
    )
}

export default HolidaySelectItems